"use strict";

document.querySelectorAll(".whatIsCfgArea").forEach(function (area, carouselIndex) {
    const slides = Array.from(area.querySelectorAll(".whatIsCfgBox"));
    if (slides.length < 2) return;

    let current = 0;
    const viewport = document.createElement("div");
    viewport.className = "cfgCarouselViewport";
    viewport.id = "cfg-carousel-" + carouselIndex;
    slides.forEach(function (slide, index) {
        slide.setAttribute("role", "group");
        slide.setAttribute("aria-roledescription", "スライド");
        slide.setAttribute("aria-label", (index + 1) + " / " + slides.length);
        viewport.appendChild(slide);
    });
    area.appendChild(viewport);
    area.setAttribute("role", "region");
    area.setAttribute("aria-roledescription", "カルーセル");
    area.setAttribute("aria-label", "キャラファインの特長");
    area.tabIndex = 0;

    const status = document.createElement("div");
    status.className = "cfgCarouselStatus";
    status.setAttribute("role", "group");
    status.setAttribute("aria-label", "スライドの選択");
    const dots = slides.map(function (slide, index) {
        const dot = document.createElement("button");
        dot.type = "button";
        dot.className = "cfgCarouselDot";
        dot.setAttribute("aria-label", (index + 1) + "枚目のスライドへ");
        dot.setAttribute("aria-controls", viewport.id);
        dot.addEventListener("click", function () { showSlide(index); });
        status.appendChild(dot);
        return dot;
    });

    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    let paused = reducedMotion.matches;
    let timer = null;
    let hovering = false;
    let touching = false;

    function updateAutoplay() {
        window.clearTimeout(timer);
        timer = null;
        if (paused || hovering || touching || document.hidden || area.contains(document.activeElement)) return;
        timer = window.setTimeout(function () { showSlide(current + 1); }, 5000);
    }

    function showSlide(index) {
        current = (index + slides.length) % slides.length;
        slides.forEach(function (slide, slideIndex) {
            slide.hidden = slideIndex !== current;
        });
        dots.forEach(function (dot, dotIndex) {
            dot.setAttribute("aria-current", dotIndex === current ? "true" : "false");
        });
        updateAutoplay();
    }

    [-1, 1].forEach(function (direction) {
        const button = document.createElement("button");
        button.type = "button";
        button.className = "cfgCarouselArrow " + (direction < 0 ? "is-prev" : "is-next");
        button.setAttribute("aria-label", direction < 0 ? "前のスライド" : "次のスライド");
        button.setAttribute("aria-controls", viewport.id);
        button.addEventListener("click", function () { showSlide(current + direction); });
        area.appendChild(button);
    });
    area.appendChild(status);
    area.addEventListener("mouseenter", function () { hovering = true; updateAutoplay(); });
    area.addEventListener("mouseleave", function () { hovering = false; updateAutoplay(); });
    area.addEventListener("focusin", updateAutoplay);
    area.addEventListener("focusout", function () { window.setTimeout(updateAutoplay, 0); });
    document.addEventListener("visibilitychange", updateAutoplay);
    reducedMotion.addEventListener("change", function () {
        paused = reducedMotion.matches;
        updateAutoplay();
    });
    area.addEventListener("keydown", function (event) {
        if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
            event.preventDefault();
            showSlide(current + (event.key === "ArrowLeft" ? -1 : 1));
        }
    });

    let touchStart = null;
    viewport.addEventListener("touchstart", function (event) {
        touching = true;
        updateAutoplay();
        touchStart = event.touches.length === 1
            ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
    }, { passive: true });
    viewport.addEventListener("touchend", function (event) {
        touching = false;
        updateAutoplay();
        if (!touchStart) return;
        const dx = event.changedTouches[0].clientX - touchStart.x;
        const dy = event.changedTouches[0].clientY - touchStart.y;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) {
            showSlide(current + (dx < 0 ? 1 : -1));
        }
        touchStart = null;
    }, { passive: true });
    viewport.addEventListener("touchcancel", function () {
        touchStart = null;
        touching = false;
        updateAutoplay();
    });
    showSlide(0);
});

$(function () {
    const $menuButton = $(".humburgerMenu");
    const $globalNav = $("#globalNav");
    const desktopMedia = window.matchMedia("(min-width: 768px)");

    function setMenuState(isOpen) {
        $menuButton
            .toggleClass("is-open", isOpen)
            .attr("aria-expanded", isOpen)
            .attr("aria-label", isOpen ? "メニューを閉じる" : "メニューを開く");
        $globalNav.toggleClass("is-open", isOpen);
        $("body").toggleClass("is-menu-open", isOpen);
    }

    $menuButton.on("click", function () {
        setMenuState($(this).attr("aria-expanded") !== "true");
    });

    $globalNav.find("a").on("click", function () {
        setMenuState(false);
    });

    $(document).on("keydown", function (event) {
        if (event.key === "Escape") {
            setMenuState(false);
        }
    });

    desktopMedia.addEventListener("change", function (event) {
        if (event.matches) {
            setMenuState(false);
        }
    });

    const $lineUpArea = $(".toLineUpArea");
    if ($lineUpArea.length) {
        const $window = $(window);
        let lineUpUpdatePending = false;

        function updateLineUpVisibility() {
            lineUpUpdatePending = false;
            const scrollTop = $window.scrollTop();
            const scrollHeight = document.documentElement.scrollHeight;
            // 小数点以下のスクロール位置による誤差を許容する。
            const isAtBottom = scrollTop + window.innerHeight >= scrollHeight - 1;
            const isVisible = scrollTop > 0 && !isAtBottom;
            $lineUpArea.toggleClass("is-visible", isVisible)
                .attr("aria-hidden", String(!isVisible));
        }

        function scheduleLineUpUpdate() {
            if (lineUpUpdatePending) return;
            lineUpUpdatePending = true;
            window.requestAnimationFrame(updateLineUpVisibility);
        }

        $window.on("scroll.lineUp resize.lineUp load.lineUp pageshow.lineUp", scheduleLineUpUpdate);
        if ("ResizeObserver" in window) {
            const lineUpResizeObserver = new ResizeObserver(scheduleLineUpUpdate);
            lineUpResizeObserver.observe(document.body);
        }
        updateLineUpVisibility();
    }
});
